function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { ConnectionType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../core-video-internal';
import { sdkLogger } from '../../logger';
import { PerfTag } from '../../utils/perf';
import { TelemetryEventType, TelemetryNotificationKey } from './telemetry.enums';
export { TelemetryEventType, TelemetryNotificationKey } from './telemetry.enums';
var DATA_LOOKBACK_SECONDS = 10;
var DEFAULT_PERIODIC_MEASUREMENT_TIME_MS = 120000;
export var TelemetrySession = /*#__PURE__*/ function() {
    "use strict";
    function TelemetrySession(sessionController, config) {
        var _this = this;
        _class_call_check(this, TelemetrySession);
        _define_property(this, "sessionController", void 0);
        _define_property(this, "getPlayerTelemetryData", void 0);
        _define_property(this, "store", void 0);
        _define_property(this, "stopMonitoring", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "periodicMeasurementInterval", void 0);
        _define_property(this, "vstTelemetryData", void 0);
        _define_property(this, "periodicMeasurementPeriodMs", void 0);
        _define_property(this, "_isInitialised", void 0);
        _define_property(this, "listenToSessionEvents", void 0);
        this.sessionController = sessionController;
        this.periodicMeasurementInterval = null;
        this.vstTelemetryData = {};
        this.periodicMeasurementPeriodMs = DEFAULT_PERIODIC_MEASUREMENT_TIME_MS;
        this._isInitialised = false;
        this.listenToSessionEvents = function() {
            _this.sessionController.onAdBreakStarted(function() {
                _this.notifyTelemetry(TelemetryEventType.AdBreakStart);
            });
            _this.sessionController.onAdBreakFinished(function() {
                _this.notifyTelemetry(TelemetryEventType.AdBreakEnd);
            });
            _this.sessionController.onError(function() {
                _this.notifyTelemetry(TelemetryEventType.EndError);
            });
            _this.sessionController.onTelemetryUpdate(function(event) {
                _this.telemetryUpdate(event);
            });
        };
        this.logger = sdkLogger.withContext('Telemetry');
        if (config === null || config === void 0 ? void 0 : config.periodicReportingSeconds) {
            this.periodicMeasurementPeriodMs = config.periodicReportingSeconds * 1000;
        }
    }
    _create_class(TelemetrySession, [
        {
            key: "isInitialised",
            get: function get() {
                return this._isInitialised;
            }
        },
        {
            key: "initialise",
            value: function initialise(getPlayerTelemetryData) {
                var _CoreVideoInternal_telemetry, _CoreVideoInternal_telemetry1;
                if (this._isInitialised) {
                    this.logger.warn('Tried to initialise Telemetry Session when it has already been initialised.');
                    return;
                }
                this.getPlayerTelemetryData = getPlayerTelemetryData;
                this.stopMonitoring = (_CoreVideoInternal_telemetry = CoreVideoInternal.telemetry) === null || _CoreVideoInternal_telemetry === void 0 ? void 0 : _CoreVideoInternal_telemetry.startMonitoring();
                this.store = (_CoreVideoInternal_telemetry1 = CoreVideoInternal.telemetry) === null || _CoreVideoInternal_telemetry1 === void 0 ? void 0 : _CoreVideoInternal_telemetry1.getMeasurementsStore();
                this.startPeriodicTelemetry();
                this._isInitialised = true;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_stopMonitoring, _this;
                this._isInitialised = false;
                this.stopPeriodicTelemetry();
                (_this_stopMonitoring = (_this = this).stopMonitoring) === null || _this_stopMonitoring === void 0 ? void 0 : _this_stopMonitoring.call(_this);
            }
        },
        {
            key: "telemetryUpdate",
            value: function telemetryUpdate(telemetryNotification) {
                // Reset vstTelemetryData for every playbackSession
                if (telemetryNotification.key === 'sessionStart') {
                    this.vstTelemetryData = {};
                }
                if (this.checkIsVstNotification(telemetryNotification.key)) {
                    this.vstTelemetryData[telemetryNotification.key] = telemetryNotification.value;
                }
            }
        },
        {
            key: "checkIsVstNotification",
            value: function checkIsVstNotification(key) {
                var vstNotificationKeys = [
                    TelemetryNotificationKey.sessionStart,
                    TelemetryNotificationKey.videoStartUp,
                    TelemetryNotificationKey.vacRequestStart,
                    TelemetryNotificationKey.vacResponseEnd,
                    TelemetryNotificationKey.ovpRequestStart,
                    TelemetryNotificationKey.ovpResponseEnd,
                    TelemetryNotificationKey.mediaTailorRequestStart,
                    TelemetryNotificationKey.mediaTailorResponseEnd,
                    TelemetryNotificationKey.trackingUrlRequestStart,
                    TelemetryNotificationKey.trackingUrlResponseEnd
                ];
                return vstNotificationKeys.includes(key);
            }
        },
        {
            key: "stopPeriodicTelemetry",
            value: function stopPeriodicTelemetry() {
                if (this.periodicMeasurementInterval) {
                    clearInterval(this.periodicMeasurementInterval);
                }
            }
        },
        {
            key: "startPeriodicTelemetry",
            value: function startPeriodicTelemetry() {
                var _this = this;
                this.periodicMeasurementInterval = setInterval(function() {
                    _this.notifyTelemetry(TelemetryEventType.Periodic);
                }, this.periodicMeasurementPeriodMs);
            }
        },
        {
            key: "buildFpsData",
            value: function buildFpsData(data) {
                var fps = data.filter(function(item) {
                    return item.tag === PerfTag.fps;
                });
                var fpsValues = fps.map(function(item) {
                    return {
                        time: item.t.currentTime,
                        value: item.value
                    };
                });
                return fpsValues;
            }
        },
        {
            key: "buildCpuData",
            value: function buildCpuData(data) {
                var cpuUsage = data.filter(function(item) {
                    return item.tag === PerfTag.cpuUsage;
                });
                var cpuValues = cpuUsage.map(function(item) {
                    return {
                        time: item.t.currentTime,
                        value: item.value
                    };
                });
                return cpuValues;
            }
        },
        {
            key: "buildDeviceTelemetryData",
            value: function buildDeviceTelemetryData() {
                if (!CoreVideoInternal.telemetry || !this.store || this.store.perflogs.length === 0) {
                    return {};
                }
                var lastElement = this.store.perflogs[this.store.perflogs.length - 1];
                var xSecondsAgo = lastElement.t.currentTime - DATA_LOOKBACK_SECONDS * 1000;
                var xSecondsData = this.store.perflogs.filter(function(el) {
                    return el.t.currentTime > xSecondsAgo;
                });
                var supportedTags = CoreVideoInternal.telemetry.getPerformanceTags();
                var telemetryData = {};
                if (supportedTags.has(PerfTag.fps)) {
                    telemetryData.fps = this.buildFpsData(xSecondsData);
                }
                if (supportedTags.has(PerfTag.memory)) {
                    telemetryData.memory = CoreVideoInternal.telemetry.getMemoryData(xSecondsData, supportedTags);
                }
                if (supportedTags.has(PerfTag.cpuUsage)) {
                    telemetryData.cpuUsage = this.buildCpuData(xSecondsData);
                }
                return telemetryData;
            }
        },
        {
            key: "populateTotalVst",
            value: function populateTotalVst(vstMetrics, telemetryData) {
                if ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.videoStartUp) && (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.sessionStart)) {
                    vstMetrics.totalVst = (telemetryData.videoStartUp - telemetryData.sessionStart) / 1000;
                }
            }
        },
        {
            key: "populateVacDownloadTime",
            value: function populateVacDownloadTime(vstMetrics, telemetryData) {
                if ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.vacRequestStart) && (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.vacResponseEnd)) {
                    vstMetrics.vacDownloadTime = ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.vacResponseEnd) - (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.vacRequestStart)) / 1000;
                }
                if (telemetryData.trackingUrlRequestStart && telemetryData.trackingUrlResponseEnd) {
                    vstMetrics.VAMDownloadTime = (telemetryData.trackingUrlResponseEnd - telemetryData.trackingUrlRequestStart) / 1000;
                }
            }
        },
        {
            key: "populateOvpDownloadTime",
            value: function populateOvpDownloadTime(vstMetrics, telemetryData) {
                if ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.ovpRequestStart) && (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.ovpResponseEnd)) {
                    vstMetrics.ovpDownloadTime = ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.ovpResponseEnd) - (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.ovpRequestStart)) / 1000;
                }
            }
        },
        {
            key: "populateMediaTailorDownloadTime",
            value: function populateMediaTailorDownloadTime(vstMetrics, telemetryData) {
                if (telemetryData.mediaTailorRequestStart && telemetryData.mediaTailorResponseEnd) {
                    vstMetrics.mediaTailorDownloadTime = ((telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.mediaTailorResponseEnd) - (telemetryData === null || telemetryData === void 0 ? void 0 : telemetryData.mediaTailorRequestStart)) / 1000;
                }
            }
        },
        {
            key: "populatePlayerEngineMetrics",
            value: function populatePlayerEngineMetrics(vstMetrics, telemetryData) {
                if (telemetryData.videoStartUp) {
                    if (telemetryData.trackingUrlResponseEnd) {
                        vstMetrics.playerEngineLoadingDownloadTime = (telemetryData.videoStartUp - telemetryData.trackingUrlResponseEnd) / 1000;
                    } else if (telemetryData.ovpResponseEnd) {
                        vstMetrics.playerEngineLoadingDownloadTime = (telemetryData.videoStartUp - telemetryData.ovpResponseEnd) / 1000;
                    }
                }
            }
        },
        {
            key: "buildVstMetrics",
            value: function buildVstMetrics() {
                var vstMetrics = {};
                this.populateTotalVst(vstMetrics, this.vstTelemetryData);
                this.populateVacDownloadTime(vstMetrics, this.vstTelemetryData);
                this.populateOvpDownloadTime(vstMetrics, this.vstTelemetryData);
                this.populateMediaTailorDownloadTime(vstMetrics, this.vstTelemetryData);
                this.populatePlayerEngineMetrics(vstMetrics, this.vstTelemetryData);
                return vstMetrics;
            }
        },
        {
            key: "notifyTelemetry",
            value: function notifyTelemetry(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _CoreVideoInternal_networkStatus, _this_store, data, _tmp, _tmp1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.getPlayerTelemetryData) {
                                    _this.logger.warn('Telemetry Session is not initialised');
                                    return [
                                        2
                                    ];
                                }
                                _tmp = {
                                    sessionMilestone: event,
                                    networkConnectionType: ((_CoreVideoInternal_networkStatus = CoreVideoInternal.networkStatus) === null || _CoreVideoInternal_networkStatus === void 0 ? void 0 : _CoreVideoInternal_networkStatus.getNetworkConnectionType()) || ConnectionType.Unknown
                                };
                                _tmp1 = [
                                    {}
                                ];
                                return [
                                    4,
                                    _this.getPlayerTelemetryData()
                                ];
                            case 1:
                                data = (_tmp.playerStats = _object_spread_props.apply(void 0, [
                                    _object_spread.apply(void 0, _tmp1.concat([
                                        _state.sent()
                                    ])),
                                    {
                                        hasSeekedAwayFromLiveEdge: _this.sessionController.getHasSeekedFromLiveEdge()
                                    }
                                ]), _tmp.vstMetrics = _this.buildVstMetrics(), _tmp.devicePerformance = _this.buildDeviceTelemetryData(), _tmp);
                                (_this_store = _this.store) === null || _this_store === void 0 ? void 0 : _this_store.reset();
                                _this.logger.verbose(data);
                                _this.sessionController.notifyTelemetry(data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TelemetrySession;
}();

//# sourceMappingURL=telemetry-session.js.map